import React from "react";
import "../../../pages/Surveys/style.css"
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";

 
import { FaTimes, FaEdit, FaFileExport,FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'


const ListPayroll = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);

  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
const [status, setstatus] = useState(10001)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const onBtnExport = useCallback((params) => {
    var params = {
      columnKeys: [
        "staff_id",
        "staff_name",
        "email",
        "role_name",
        "office_name",
        "contract_start_date",
        "contract_end_date",
        "contract_expires_after",
      ],
      fileName: `EmployeeList-${window.h.get_half_formattedDate()}.csv`,
    };
    gridRef.current.api.exportDataAsCsv(params);
  }, []);
  useEffect(() => {
    fetch_data(status);
    return () => {};
  }, []);

  const fetch_data = (_status) => {
    setIsLoading(true);
 
    genericPost(ENDPOINTS.LIST_PAYROLLS, {
      "status": _status
  })
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  return (
    <div>
      <div className="row">
      <div className="col-md-10">
          <h1> Payroll List</h1>
        

      
          Filter by Status
         <select name="status" style={{width:"150px"}}
            className="form-control"
            onChange={(e) => {
              setstatus(e.target.value)
              fetch_data(e.target.value);
            }
               
             
            }
            required={true}
          >
         
            <option value={10001}>Final </option>
            <option value={10002}>Deactivated </option>
            <option value={10003}>Draft </option>


            </select> <br></br>
        </div>
      </div>
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Payroll Name",
              field: "payroll_name",
              sortable: true,
              filter: true,
            },
          
            {
              headerName: "Month ",
              field: "month",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Year  ",
              field: "year",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Total employees ",
              field: "total_employees",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Payroll Amount ",
              field: "payroll_amount",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Status  ",
              field: "status",
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
                return (
<b>{status==10001?"Final":status==10003?"Draft":"De-activated"}</b>
                );
              }
            },
            {
              headerName: "Actions",
              field: "",
              sortable: true,
              filter: true,
              cellStyle: function (params) {
                if (
                  Number(params.node.data.contract_expires_after) < 30 &&
                  Number(params.node.data.contract_expires_after) > 10
                ) {
                  return { color: "white", backgroundColor: "#E97451" };
                } else if (
                  Number(params.node.data.contract_expires_after) < 10 &&
                  Number(params.node.data.contract_expires_after) > 0
                ) {
                  return { color: "white", backgroundColor: "#EE4B2B" };
                } else if (
                  Number(params.node.data.contract_expires_after) < 0
                ) {
                  return { color: "white", backgroundColor: "red" };
                } else {
                  return null;
                }
              }, 
              cellRendererFramework: (e) => {
                return (
                  <div>
       {ability.can(PERMS.UPDATE, PERMS.UPDATE_SURVEYS) && (

                  <button
                  className="badge btn-primary"
                    onClick={() => {
                   

                      history.push({
                        pathname: LOCAL_PATHS.PAYROLL_DETAILS,
                        state: { data: e.data },
                      });
                    }}
                  >
                   
                    
                    VIEW DETAILS  &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>)}</div>

                );
              },
            },
          ]}
        ></AgGridReact>
      </div>{" "}
    </div>
  );
};

export default ListPayroll;
